import { useState, useEffect } from 'react';
import { InputTextCustom, InputDate, Combobox } from 'medere-ui-framework';
import GeneralRecipeViewCard from '../../Components/GeneralRecipeViewCard';
import './PatientStep.scss';
import { Icon } from '@iconify/react';
import { ERecipeViews, EAgendaViews, ESteps } from '../../RecipeEnums';
import { getPatientsInfo } from '../../../../services/digitalRPservice';
import { HealthPatientCoverage, PatientRecordDTO, Medicine, defaultHealthPatientCoverage } from '../../../../interface/interface';
import { Button } from 'primereact/button';

export default function PatientStep(params: { professionalName: string, setSelectedPatient: (patient: PatientRecordDTO | null) => void, onValidationChange: (isValid: boolean) => void, isStepValid: boolean, selectedPatient: PatientRecordDTO | null, selectedCoverage:HealthPatientCoverage|undefined, setSelectedCoverage: (coverage: HealthPatientCoverage|undefined) => void, medications:Medicine[]|null, setMedications: (meds: Medicine[]) => void, setProlongedTreatment: (prolonged: boolean) => void, setHidePatientData: (hiding: boolean) => void, recipeDate: Date, setRecipeDate: (rp: Date) => void, handleNext: () => void, handleBack: () => void, setActiveView: (av: number|undefined) => void, subActiveView:number|undefined, setSubActiveView: (av: number|undefined) => void, prevActiveView:number|undefined, setPrevActiveView: (pav: number|undefined) => void, prevSubActiveView:number, setPrevSubActiveView: (pav: any) => void, setMonthDurationPrescription: (mdp:{months: number, description: string}) => void }) {
    const [isMobile, setisMobile] = useState(window.innerWidth < 700)
    const { professionalName, setSelectedPatient, onValidationChange, isStepValid, selectedPatient, selectedCoverage, setSelectedCoverage, setMedications, setProlongedTreatment, setHidePatientData, recipeDate, setRecipeDate, handleNext, handleBack, setActiveView, setSubActiveView, setPrevActiveView, setPrevSubActiveView, setMonthDurationPrescription } = params;
    const [patientInput, setPatientInput] = useState('');
    const [searchResults, setSearchResults] = useState<PatientRecordDTO[]>([]);
    const [activeCard, setActiveCard] = useState<number | null>(null);
    const [resultsFound, setResultsFound] = useState(isMobile ? '' : 'Todavía no se han ingresado datos de búsqueda');
    const [loading, setLoading] = useState(false);

    useEffect(() => {

        setRecipeDate(generateDate())

        const handleResize = () => {
            setisMobile(window.innerWidth < 700);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (selectedCoverage && selectedPatient){
            selectedPatient.insurances?.forEach(hpc => {
                if (selectedCoverage.healthpatientcoverage === hpc.healthpatientcoverage)
                    hpc.primarycoverage=true
                else 
                    hpc.primarycoverage=false
            })
        }
    }, [selectedCoverage]);

    useEffect(() => {
        if (selectedPatient && selectedCoverage?.healthentityplan.healthentityplan===0)
            setSelectedCoverage(selectedPatient?.insurances?.find(insurance => insurance.primarycoverage) ?? defaultHealthPatientCoverage)

        onValidationChange(!!recipeDate && !!selectedPatient);
    }, [recipeDate, selectedPatient, onValidationChange]);


    useEffect(() => {
        if (selectedPatient && !isValidPatientRecord(selectedPatient))
            handleGoToEditPatient()
    }, [selectedPatient]);

    function generateDate() {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate());

        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1;
        const day = currentDate.getDate();

        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;

        const formattedDate = `${year}-${formattedMonth}-${formattedDay}T03:00:00.000Z`;

        return new Date(formattedDate);
    }

    const handleGoToEditPatient = () => {
        setPrevSubActiveView(ESteps.PATIENTSTEP)
        setPrevActiveView(ERecipeViews.NEWRECIPE)
        setSubActiveView(EAgendaViews.CREATEPATIENTVIEW)
        setActiveView(ERecipeViews.PATIENTAGENDA)
    }

    const handleSearch = async () => {
        if (!patientInput) {
            setResultsFound((searchResults?.length === 0 && !patientInput) ? 'Todavía no se han ingresado datos de búsqueda' : '');
            return;
        }
    
        try {
            setLoading(true);
            const results = await getPatientsInfo(patientInput, 500, 0);
            setSearchResults(results);
            setResultsFound((!results || results?.length === 0) ? 'No se han encontrado resultados' : '');
        } catch (error) {
            setSearchResults([]);
            setResultsFound('No se han encontrado resultados');
        } finally {
            setLoading(false);
        }
    };
    
    const handleKeyDown = (e:any) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    const handlePatientSelection = (patient: PatientRecordDTO, index: number) => {
        setActiveCard(index);
        setTimeout(() => {
            setSelectedCoverage(patient?.insurances?.find(insurance => insurance.primarycoverage) ?? defaultHealthPatientCoverage);
            setMedications([]);
            setProlongedTreatment(false);
            setHidePatientData(false);
            setMonthDurationPrescription({months: 1, description: '1 mes'})
            setSelectedPatient(patient);
            setActiveCard(null);
        }, 100);

    }

    const removePatientSelection = () => {
        setSelectedPatient(null);
    }

    const renderProfessionalNameAndRecipeDate = () => (
        <>
            <div style={{ paddingBottom: '30px' }}>
                <b><label>Profesional que prescribe</label> <br/></b>
                <label> {professionalName} </label>
            </div>
            <div style={{ paddingBottom: '30px' }}>
                <label><strong>Fecha de receta</strong></label>
                <InputDate className='border2' value={recipeDate} onChange={(e: any) => setRecipeDate(e.target.value)}/>
            </div>
        </>
    )

    const renderPatientSearch = () => (
        <div style={{ marginBottom: '30px', marginTop: '-8px' }} className="patient-search-container">
            <InputTextCustom
                className={`patient-input ${patientInput ? 'active' : ''} border2`}
                value={patientInput}
                onChange={(e) => setPatientInput(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="Buscar por apellido, nombre o DNI"
                style={{ minWidth: '300px' }}
                disable={selectedPatient!=null && selectedPatient?.medereentity > 0}
            />
            <i
                className={`${loading ? 'pi pi-spinner pi-spin patient-search-icon':'pi pi-search patient-search-icon btnRpContinue'} ${(loading || (selectedPatient && selectedPatient?.medereentity > 0)) ? 'disabled' : ''}`}
                onClick={selectedPatient && selectedPatient?.medereentity > 0 ? undefined : handleSearch}
                style={{
                    cursor: (loading || (selectedPatient && selectedPatient?.medereentity > 0)) ? 'not-allowed' : 'pointer',
                    opacity: loading ? 0.7 : (selectedPatient && selectedPatient?.medereentity > 0 ? 0.5 : 1),
                    marginTop: loading ? '-7px': '',
                    color: loading ? '' : 'white',
                    backgroundColor: loading ? '' : '#3CB8BA',
                    padding: loading ? '' : '12.8px',
                    marginRight: loading ? '' : '-7px',
                    borderRadius: '2px'
                }}
            />
        </div>
    )

    const renderSelectedPatientCard = () => (
        <GeneralRecipeViewCard
            style={{ minWidth: '400px' }}
            title={<strong>{selectedPatient?.firstname + " " + selectedPatient?.lastname}</strong>}
            detail={<div style={{ paddingBottom: '4px' }} className="patient-affiliate">Afiliado: {(selectedPatient?.insurances?.length??0) > 1 ? selectedCoverage?.benefitnumber : (selectedPatient?.insurances?.length === 1 ? selectedPatient?.insurances[0]?.benefitnumber : "-")}</div>}
            detail2={
                <>
                    {(selectedPatient?.insurances?.length??0) > 1 ? (
                        <div>
                            <div className="patient-affiliate">Obra social</div>
                            <Combobox
                                className='border2'
                                getItems={() => Promise.resolve(selectedPatient?.insurances)}
                                placeholder="Seleccionar obra social"
                                optionLabel={'description'}
                                value={selectedCoverage}
                                setValue={(e) => {
                                    setSelectedCoverage(e);
                                }}
                            />
                        </div>
                    ) : (selectedPatient?.insurances?.length === 1 ? (
                        <div style={{ paddingBottom: '4px' }} className="patient-insurances">Obra social: {(selectedPatient.insurances[0].healthentityplan.healthentity.commercialname + ", " + selectedPatient.insurances[0].healthentityplan.name)}</div>
                    ) : (
                        <div>Sin obra social</div>
                    ))}
                </>
            }
            detail3={<div style={{ paddingBottom: '4px' }} className="patient-phone">Cel.: {selectedPatient?.mobilephone}</div>}
            onClick={() => {}}
            onRemove={removePatientSelection}
            onEdit={handleGoToEditPatient}
            backgroundColor='#FFFFFF'
            titleColor='#000000'
        />
    )

    function isValidPatientRecord(dto: PatientRecordDTO): boolean {
        if (!dto.firstname || dto.firstname.trim() === '') return false;
        if (!dto.lastname || dto.lastname.trim() === '') return false;
        if (!dto.document || dto.document.trim() === '') return false;
        if (!dto.gender || dto.gender.trim() === '') return false;
        if (!dto.birthdate || (typeof dto.birthdate === 'string' && dto.birthdate.trim() === '')) return false;
    
        return true;
    }
    

    if (isMobile)
        return (
            <div className="patient-step">
                {renderProfessionalNameAndRecipeDate()}
                <div className="field">
                    <label style={{ marginTop: '-7px' }}>Paciente</label>
                    {!selectedPatient && (
                        renderPatientSearch()
                    )}
                    {!selectedPatient && (
                        <div>
                            <div style={{ marginTop: '-25px' }} className="create-patient-container">
                                <button onClick={handleGoToEditPatient} className="create-patient-button">
                                    <Icon icon='bi:person-plus-fill' style={{ fontSize: '34px', padding: '8px', backgroundColor: '#ECECEC', borderRadius: '100%' }} />
                                    Crear paciente
                                </button>
                            </div>
                            {searchResults?.length > 0 && (
                                <div className="search-results">
                                    {<div className="search-results-title">Resultados de búsqueda:</div>}
                                    {<div /*className="cards-container"  quitar comentado si se quiere poner en contenedor el scroller*/>
                                        {searchResults?.map((patient:PatientRecordDTO, index) => (
                                            <GeneralRecipeViewCard
                                                key={index}
                                                title={<strong>{patient.firstname + " " + patient.lastname + " ("+ "DNI " +patient.document+ " - "+patient.birthdate+")"}</strong>}
                                                detail={"Afiliado: " + (patient.insurances?.find(insurance => insurance.primarycoverage) ? patient.insurances.find(insurance => insurance.primarycoverage)?.benefitnumber : "-")}
                                                detail2={patient.insurances?.find(insurance => insurance.primarycoverage) ? patient.insurances.find(insurance => insurance.primarycoverage)?.healthentityplan?.healthentity?.commercialname+", "+patient.insurances.find(insurance => insurance.primarycoverage)?.healthentityplan?.name : "-, -"}
                                                onClick={() => {
                                                    handlePatientSelection(patient, index)
                                                }}
                                                backgroundColor='#EAEFEE'
                                                titleColor='#009688'
                                                changeColorIfActive={activeCard === index}
                                            />
                                        ))}
                                    </div>}
                                </div>
                            )}
                            {searchResults?.length === 0 && (
                                <p style={{color:'#000000', fontSize:'14px', fontFamily:'sans-serif', fontStyle:'italic'}}>{resultsFound}</p>
                            )}
                        </div>
                    )}
                    {selectedPatient && (
                        renderSelectedPatientCard()
                    )}
                </div>
            </div>
        );
    else
        return (
            <div className="patient-step" style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{ flex: '1', marginRight: '2rem' }}>
                    {renderProfessionalNameAndRecipeDate()}
                    <div className="field">
                        <label style={{ marginTop: '-7px' }}>Paciente</label>
                        {renderPatientSearch()}
                        {!selectedPatient && (
                            <div style={{ marginTop: '-25px' }} className="create-patient-container">
                                <button onClick={handleGoToEditPatient} className="create-patient-button">
                                    <Icon icon='bi:person-plus-fill' style={{ fontSize: '34px', padding: '8px', backgroundColor: '#ECECEC', borderRadius: '100%' }} />
                                    Crear paciente
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                    <div className="field" style={{ borderLeft: '4px solid rgba(28, 50, 79, 0.38)', paddingLeft: '1rem', marginRight: '1rem', flex: '1', display: 'flex', flexDirection: 'column' }}>
                        {!selectedPatient && (
                            <div style={{ flex: '1' }}>
                                <div className="search-results">
                                    <div className="search-results-title" style={{ marginTop: '-15px' }}>Resultados de búsqueda:</div>
                                    {searchResults?.length === 0 && (
                                            <p style={{ color: '#000000', fontSize: '14px', fontFamily: 'sans-serif', fontStyle: 'italic' }}>{resultsFound}</p>
                                        )
                                    }
                                    <div className="cards-container" style={{ height: 'fit-content', minHeight: '298px', maxHeight: '500px' }}>  
                                        {searchResults?.map((patient: PatientRecordDTO, index) => (
                                            <GeneralRecipeViewCard
                                                key={index}
                                                style={{ minWidth: '312px' }}
                                                title={<strong>{patient.firstname + " " + patient.lastname + " ("+ "DNI " +patient.document+ " - "+patient.birthdate+")"}</strong>}
                                                detail={"Afiliado: " + (patient?.insurances?.find(insurance => insurance.primarycoverage) ? patient.insurances.find(insurance => insurance.primarycoverage)?.benefitnumber : "-")}
                                                detail2={patient?.insurances?.find(insurance => insurance.primarycoverage) ? patient.insurances.find(insurance => insurance.primarycoverage)?.healthentityplan.healthentity.commercialname + ", " + patient.insurances.find(insurance => insurance.primarycoverage)?.healthentityplan.name : "-, -"}
                                                onClick={() => {
                                                    handlePatientSelection(patient, index)
                                                }}
                                                backgroundColor='#EAEFEE'
                                                titleColor='#009688'
                                                changeColorIfActive={activeCard === index}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}

                        {selectedPatient && isValidPatientRecord(selectedPatient) && (
                            <div style={{ marginTop: '-10px', display: 'flex', minHeight: '333px' }}>
                                <div className="selected-patient">
                                    <p style={{ fontWeight: 600, fontSize: '18px', paddingBottom: '10px', marginTop: '-15px' }}>Paciente seleccionado</p>
                                    {renderSelectedPatientCard()}
                                </div>
                            </div>
                        )}
                    </div>

                    <div style={{ padding: '15px', display: 'flex', flexDirection: 'column', marginTop: 'auto' }}>
                        <div style={{ display: 'flex', justifyContent: 'start', gap: '1rem' }}>
                            <Button
                                className='btnRpContinue'
                                label={"Continuar"}
                                onClick={handleNext}
                                disabled={!isStepValid}
                                style={{ width: '170px', backgroundColor: isStepValid ? '#14C7BC' : '#9E9E9E', border: 'none', height: '36px' }}
                            />
                            <Button
                                className='btnRpBack'
                                label={"Cancelar receta"}
                                onClick={handleBack}
                                style={{ width: '170px', backgroundColor: '#FFFFFF', color: '#545454', height: '36px', border: '1px solid #3CB8BA' }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
}
